import React from 'react';
import { Paper, Typography, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const objectOptions = [
  { label: 'Assistência / Orientação Técnica', value: 'assistencia_orientacao_tecnica' },
  { label: 'Assistência Técnica e Extensão Rural - ATER', value: 'ater' },
  { label: 'Horas-trator / Máquina (Com custo)', value: 'horas_trator_maquina_com_custo' },
  { label: 'Horas-trator / Máquina (Gratuitamente)', value: 'horas_trator_maquina_gratuitamente' },
  { label: 'Fornecimento de Insumos (Calcário, fertilizantes, sementes, mudas)', value: 'fornecimento_insumos' },
  { label: 'Apoio à elaboração de projetos de crédito rural', value: 'projetos_credito_rural' },
  { label: 'Realização de eventos (Dias de campo, cursos, seminários)', value: 'eventos' },
  { label: 'Associativismo e Cooperativismo', value: 'associativismo_cooperativismo' },
  { label: 'Acesso à água para consumo', value: 'acesso_agua_consumo' },
  { label: 'Irrigação', value: 'irrigacao' },
  { label: 'Avicultura', value: 'cadeia_avicultura' },
  { label: 'Apicultura', value: 'cadeia_apicultura' },
  { label: 'Orizicultura (Arroz na agricultura familiar)', value: 'cadeia_arroz' },
  { label: 'Cacauicultura', value: 'cadeia_cacauicultura' },
  { label: 'Cafeicultura', value: 'cadeia_cafeicultura' },
  { label: 'Floricultura', value: 'cadeia_floricultura' },
  { label: 'Fruticultura', value: 'cadeia_fruticultura' },
  { label: 'Mandiocultura', value: 'cadeia_mandioca' },
  { label: 'Olericultura', value: 'cadeia_olericultura' },
  { label: 'Pecuária de Leite', value: 'cadeia_pecuaria_leite' },
  { label: 'Pecuária de Corte', value: 'cadeia_pecuaria_corte' },
  { label: 'Piscicultura', value: 'cadeia_piscicultura' },
  { label: 'Sistemas Agroflorestais (SAFs)', value: 'cadeia_safs' },
  { label: 'Plantas Medicinais, Aromáticas e Condimentares', value: 'cadeia_plantas_medicinais' },
  { label: 'Produção Agroecológica', value: 'producao_agroecologica' },
  { label: 'Produção Orgânica', value: 'producao_organica' },
  { label: 'Serviço de Inspeção Municipal - SIM', value: 'sim' },
  { label: 'Apoio à realização de feiras (Livres e/ou Permanentes)', value: 'apoio_feiras' },
  { label: 'Apoio ao PNAE (Merenda Escolar)', value: 'projetos_pnae' },
  { label: 'Apoio ao PAA (Aquisição de Alimentos Federal)', value: 'propostas_paa' },
  { label: 'Programa Municipal de Aquisição de Alimentos (Recursos Próprios)', value: 'programa_aquisicao_alimentos' },
  { label: 'Compras Governamentais Municipais', value: 'compras_governamentais' },
  { label: 'Comercialização em Canais Convencionais (Mercados, Hotéis)', value: 'comercializacao_convencional' },
  { label: 'Comercialização Eletrônica (Sites, Apps)', value: 'comercializacao_eletronica' },
  { label: 'Apoio na emissão de Nota Fiscal', value: 'cadastro_nota_fiscal' },
  { label: 'Declaração de Produção para Inscrição Estadual', value: 'declaracao_producao_ie' },
  { label: 'Ações para Juventude Rural', value: 'juventude_rural' },
  { label: 'Ações para Mulheres Rurais', value: 'mulheres_rurais' },
  { label: 'Ações para Povos Indígenas', value: 'indigenas' },
  { label: 'Ações para Quilombolas', value: 'quilombolas' },
  { label: 'Ações para Outros Povos e Comunidades', value: 'pct' },
  { label: 'Artesanato Rural', value: 'artesanato' },
  { label: 'Geoprocessamento', value: 'geoprocessamento' },
  { label: 'Licenciamento Ambiental', value: 'licenciamento_ambiental' },
  { label: 'Cadastro Ambiental Rural - CAR', value: 'car' },
  { label: 'Preservação Ambiental', value: 'preservacao_ambiental' },
  { label: 'Extrativismo e Sociobiodiversidade', value: 'extrativismo' },
  { label: 'Manejo Ambiental', value: 'manejo_ambiental' },
  { label: 'Recuperação de Áreas Degradadas', value: 'recuperacao_ambiental' },
  { label: 'Economia Solidária', value: 'economia_solidaria' },
  { label: 'Segurança Alimentar e Nutricional', value: 'seguranca_alimentar' },
  { label: 'Outro', value: 'other' },
];

interface Demand {
  object: string;
  quantity: number;
  justification: string;
  year: number;
}

interface Step5CmdrsViewProps {
  data: {
    demands: Demand[];
  };
}

const Step5CmdrsView: React.FC<Step5CmdrsViewProps> = ({ data }) => (
  <Paper elevation={1} sx={{ p: 3, mt: 2 }}>
    <Typography variant="h5" color="primary" gutterBottom>
      Demandas do CMDRS
    </Typography>
    <Divider sx={{ mb: 3 }} />

    {data.demands && data.demands.length > 0 ? (
      <TableContainer component={Paper} elevation={0}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><strong>Objeto</strong></TableCell>
              <TableCell><strong>Quantidade</strong></TableCell>
              <TableCell><strong>Justificativa</strong></TableCell>
              <TableCell><strong>Ano</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.demands.map((demand, idx) => (
              <TableRow key={idx}>
                <TableCell>{objectOptions.find(opt => opt.value === demand.object)?.label ?? demand.object}</TableCell>
                <TableCell>{demand.quantity ?? 'Não informado'}</TableCell>
                <TableCell>{demand.justification || 'Não informado'}</TableCell>
                <TableCell>{demand.year ?? 'Não informado'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    ) : (
      <Typography color="text.secondary">Nenhuma demanda cadastrada.</Typography>
    )}
  </Paper>
);

export default Step5CmdrsView;
